import React from 'react';
import {Button} from 'MWC';
import './less/transfers-to-card.less';

export default function tmp() {
    return (
        <div className="transfers-to-card-block">
            <div className="download-content">
                <div className="app-description">
                    <p className="app-description-title">
                        {this.l10n('BUSINESS_TRANSFER_TO_CARD_TITLE')}
                    </p>
                    <p className="app-description-text">
                        {this.l10n('BUSINESS_TRANSFER_TO_CARD_TEXT')}
                    </p>

                    <Button primary onClick={e => this.props.callback()} className={'btn-success'}>
                        {this.l10n('BUSINESS_GET_CONSULT')}
                    </Button>
                </div>

                <div className="app-banner">
                    <div className="app-banner-img"></div>
                </div>
            </div>
        </div>
    );
}
